"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Types = void 0;
var Types = {
  Number: 'number',
  String: 'string',
  Boolean: 'boolean',
  DateTime: 'dateTime',
  Any: 'any',
  Array: 'array',
  Object: 'object'
};
exports.Types = Types;